<template lang="html">
    <div class="d-flex flex-column h-100 position-relative">

        <div class="navigator" style="height: 65px;">
            <h2 class="mr-auto">Promocodes</h2>

            <div>
                <button class="btn blue wide mr-3" @click="cancelBtn">
                    Cancel
                </button>

                <button class="btn wide mr-3" @click="saveBtn" :class="{'disabled': isPromocodeInvalid}">
                    Save
                </button>

                <button class="btn wide mr-3" @click="publishBtn" :class="{'disabled': isPromocodeInvalid}">
                    Publish
                </button>

                <button class="btn wide blue" @click="pressSeeAffectedEvents" :class="{'disabled': isPromocodeInvalid}" >
                    Preview list of events
                </button>

            </div>
        </div>

        <!-- white area -->
        <div class="px-3 py-4 d-flex flexGrow1 overflow-auto">
            <div class="col-sm-12 bg-lightest">
                <promocode-form :promocode="promocode" @change="promocodeChanged"></promocode-form>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import PromocodeForm from './components/promocodeForm'
export default {
    data: function () {
        return {
            isPromocodeInvalid: true,
            promocode: null,
            promocodeValidation: null
        }
    },
    created: function () {
        this.promocode = JSON.parse(JSON.stringify(this.getVirginPromocode))
    },
    computed: {
        ...mapGetters([
            'getVirginPromocode',
        ]),
    },
    methods: {
        ...mapActions([
            'createPromocodeDraft',
            'createPromocodeActive',
            'setSelectedPromocode',
            'openModal',
        ]),
        cancelBtn: function () {
            this.$router.push({name:'promocodes'})
        },
        saveBtn: function () {
            if(!this.isPromocodeInvalid){
                this.createPromocodeDraft(this.promocode).then(response => {
                    this.$router.push({name:'promocodes'})
                })
            } else {
                this.promocodeValidation.promocode.$touch()
            }
        },
        publishBtn: function () {
            if(!this.isPromocodeInvalid){
                this.createPromocodeActive(this.promocode).then(response => {
                    this.$router.push({name:'promocodes'})
                })
            } else {
                this.promocodeValidation.promocode.$touch()
            }
        },
        promocodeChanged: function (e) {
            this.isPromocodeInvalid = e.v.promocode.$invalid
            this.promocodeValidation = e.v
        },
        pressSeeAffectedEvents: function () {
            if(this.isPromocodeInvalid){
                this.promocodeValidation.promocode.$touch()
                return false
            }
            this.setSelectedPromocode(this.promocode)
            this.openModal('PromocodeAffectedEvents')
        }
    },
    components: {
        PromocodeForm
    },
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// promocodeCreate.vue?236b8c40